import type { ActivationObjectSchema } from "app/pages/activation/types/api";

export const getExistingNames = (activationSetList: ActivationObjectSchema[]) =>
    activationSetList.map((activationSet) => activationSet?.name);
